export default {
  identifyUser,
};

function identifyUser(user) {
  if (!window.smartlook) {
    return;
  }

  if (!user) {
    window.smartlook('identify', null);
  } else {
    const smartlookParams = {
      firstName: user.first_name,
      lastName: user.last_name,
      email: user.email,
      createdAt: user.created_at,
      userType: _.get(user, 'user_type.name', ''),
      roles: (user.roles || [])
        .map(role => _.get(role, 'name', null))
        .filter(v => v)
        .join(', '),
    };
    window.smartlook('identify', user.uuid, smartlookParams);
  }
}
